import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d327862"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phase__accordion tw-w-full tw-max-w-full" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-max-w-full tw-w-[calc(100%_-_35px)] md:tw-flex-col md:tw-items-start md:tw-w-full" }
const _hoisted_3 = { class: "phase_list_summary tw-relative tw-flex tw-gap-4 tw-items-center tw-w-[calc(100%-170px)] tw-max-w-full tw-justify-end md:tw-w-full md:tw-justify-start md:tw-flex-col-reverse md:tw-items-start md:tw-gap-2" }
const _hoisted_4 = { class: "tw-flex tw-gap-2 tw-items-center tw-pr-2 tw-flex-wrap" }
const _hoisted_5 = { class: "phase-received-item__item tw-flex tw-gap-2 tw-items-start tw-pr-2" }
const _hoisted_6 = {
  key: 0,
  class: "phase-received-item__item tw-flex tw-gap-2 tw-items-start tw-pr-2"
}
const _hoisted_7 = { class: "phase-received-item__item tw-flex tw-gap-2 tw-items-start tw-pr-2" }
const _hoisted_8 = { class: "tw-flex tw-gap-2 tw-items-center tw-pr-2" }
const _hoisted_9 = { class: "tw-flex tw-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "tw-max-w-[24px] tw-min-w-[24px] tw-max-h-[24px] text-[14] tw-min-h-[24px] tw-bg-[#DCECFE] tw-rounded-full tw-flex tw-justify-center tw-items-center tw-z-[100]"
}
const _hoisted_11 = { class: "tw-flex tw-flex-col tw-w-full" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "tw-flex tw-gap-4 tw-items-center tw-pr-4" }
const _hoisted_15 = { class: "tw-pr-4 tw-flex tw-gap-3 tw-items-start" }
const _hoisted_16 = {
  key: 0,
  class: "tw-pr-4 tw-flex tw-gap-3 tw-items-start"
}
const _hoisted_17 = {
  key: 1,
  class: "tw-pr-4 tw-flex tw-gap-3 tw-items-start"
}
const _hoisted_18 = { class: "tw-pr-4 tw-flex tw-gap-3 tw-items-start" }

import moment from "moment";
import { ref, reactive, onMounted } from "vue";
import Text from "@/core/components/ui/general/Text.vue";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import PhaseTitle from "@/modules/project/components/common/PhaseTitle.vue";
import AddressItem from "@/modules/project/components/common/AddressItem.vue";
import { DurationsType, EstimatePhaseType } from "@/core/enums/estimateEnum";
import CurrencyFilter from "@/filters/currency.filter";
import ShowPhaseNoteModal from "@/modules/project/modal/ShowPhaseNoteModal.vue";
import { getImageStringToImageURL } from "@/core/utils/common";

import { computed } from "vue";
import ShowPhaseProofOfWorkModal from "../../modal/ShowPhaseProofOfWorkModal.vue";


const __default__ = {
  name: "PhaseReceivedItem",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ["phase", "phaseIndex", "grantEstimateDetails"],
  setup(__props) {

const props = __props;
const isShowPhaseNoteListModal = ref(false);
const isShowPhaseProofOfWorkModal = ref(false);

const getDurationType = (durationsType: number) => {
  if (durationsType === DurationsType.DAY) {
    return "day(s)";
  }
  return "week(s)";
};

const phasePropertyCount = computed(() => {
  if (props?.phase?.phaseType === EstimatePhaseType.LABOUR) {
    const uniquePropertyIds = Array.from(
      new Set(
        (props.phase?.estimationPhaseTasks || []).flatMap(
          (task: any) =>
            task.estimationPhaseTasksProperties?.map(
              (property: any) => property?.property.id
            ) || []
        )
      )
    );
    return uniquePropertyIds?.length || 0;
  } else {
    return props.phase.estimationPhaseProperties?.length || 0;
  }
});

const phaseTotal = (phase: any) => {
  let subTotal = phase?.subTotal;
  if (phase?.phaseType === EstimatePhaseType.LABOUR) {
    subTotal = subTotal - props.grantEstimateDetails.grantDiscountTotal;
  }
  return formatCurrency(subTotal);
};

const formatCurrency = (value: any) => {
  if (!value) return `£0`;
  return CurrencyFilter.formatToCurrency(value);
};
const phaseAssignContractorAndMembers = ref<any>([]);
const getDuration = (
  taskStartDate: any,
  taskEndDate: any,
  durationType: number
) => {
  if (!taskStartDate || !taskEndDate) return 0;

  const start = moment(taskStartDate);
  const end = moment(taskEndDate);
  const duration = moment.duration(end.diff(start));

  if (durationType === DurationsType.DAY) {
    return duration.days();
  }
  return duration.weeks();
};

const getPropertyAdditionalCount = (count: number) => {
  if (count > 1) {
    return count - 1;
  }
  return;
};

const getPropertiesFirstValue = (properties: any) => {
  if (properties && properties.length) {
    return properties[0].property.address;
  }
  return "";
};
const toggleShowPhaseNoteListModal = () => {
  if (props.phase?.phaseNotes?.length)
    isShowPhaseNoteListModal.value = !isShowPhaseNoteListModal.value;
};
const togglePhaseProofOfWorkModal = () => {
  isShowPhaseProofOfWorkModal.value = !isShowPhaseProofOfWorkModal.value;
};
onMounted(async () => {
  if (props.phase?.assignPhaseWorkStation) {
    let imageUrl = await getImageStringToImageURL(
      props.phase?.assignPhaseWorkStation?.profileImage
    );
    phaseAssignContractorAndMembers.value.push({
      imageUrl,
      name: props.phase?.assignPhaseWorkStation?.name,
    });
  }
  if (props.phase?.assignTeamMembers.length) {
    props.phase.assignTeamMembers.forEach(async (element: any) => {
      let imageUrl = await getImageStringToImageURL(
        element?.userWorkstationMember?.toUser?.userPublicProfile?.profileImage
      );
      phaseAssignContractorAndMembers.value.push({
        imageUrl,
        name: `${element?.userWorkstationMember?.toUser?.firstName} ${element?.userWorkstationMember?.toUser?.lastName}`,
      });
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_expansion_panel, { class: "phase-received-item !tw-rounded-[10px]" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_expansion_panel_title, { class: "tw-flex tw-items-center" }, {
          default: _withCtx(() => [
            _createElementVNode("main", _hoisted_2, [
              _createVNode(PhaseTitle, {
                title: __props.phase.name,
                phaseNumber: __props.phaseIndex + 1,
                estimate: __props.phase,
                textColor: __props.phase?.color || '#4A92E5'
              }, null, 8, ["title", "phaseNumber", "estimate", "textColor"]),
              _createElementVNode("section", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    onClick: _withModifiers(togglePhaseProofOfWorkModal, ["stop"]),
                    class: "phase-received-item__item tw-flex tw-gap-2 tw-items-start tw-pr-2"
                  }, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "16px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.phase?.estimatePhaseAttachment?.length || 0), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(Text, {
                      lineHeight: "16px",
                      variant: "span",
                      textWeight: "400",
                      textColor: "rgba(12, 15, 74, 0.5)"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.phase?.estimatePhaseAttachment?.length > 1
                      ? "Attachments"
                      : "Attachment"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    onClick: _withModifiers(toggleShowPhaseNoteListModal, ["stop"]),
                    class: "phase-received-item__item tw-flex tw-gap-2 tw-items-start tw-pr-2"
                  }, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "16px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.phase?.phaseNotes?.length || 0), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(Text, {
                      lineHeight: "16px",
                      variant: "span",
                      textWeight: "400",
                      textColor: "rgba(12, 15, 74, 0.5)"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.phase?.phaseNotes?.length > 1 ? "Notes" : "Note"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "16px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.phase?.estimationPhaseTasks.length), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(Text, {
                      lineHeight: "16px",
                      variant: "span",
                      textWeight: "400",
                      textColor: "rgba(12, 15, 74, 0.5)"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.phase?.estimationPhaseTasks.length > 1 ? "tasks" : "task"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (__props.phase?.phaseType === _unref(EstimatePhaseType).LABOUR)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(Text, {
                          variant: "span",
                          lineHeight: "16px"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getDuration(
                    __props.phase?.phaseStartDate,
                    __props.phase?.phaseEndDate,
                    __props.phase.durationType
                  )), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(Text, {
                          lineHeight: "16px",
                          variant: "span",
                          textWeight: "400",
                          textColor: "rgba(12, 15, 74, 0.5)"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getDurationType(__props.phase.durationType)), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "16px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(phaseTotal(__props.phase)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(Text, { variant: "span" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(phasePropertyCount.value), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(Text, {
                      lineHeight: "16px",
                      variant: "span",
                      textWeight: "400",
                      textColor: "rgba(12, 15, 74, 0.5)"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`Propert${phasePropertyCount.value > 1 ? "ies" : "y"}`), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phaseAssignContractorAndMembers.value.slice(0, 3), (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                      (item.imageUrl)
                        ? (_openBlock(), _createBlock(ProfileThumbnail, {
                            key: 0,
                            class: "tw-mr-[-.5rem]",
                            mobilSize: "sm",
                            size: "sm",
                            src: item.imageUrl
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock(ProfileThumbnail, {
                            key: 1,
                            class: "tw-mr-[-.5rem]",
                            mobilSize: "sm",
                            size: "sm",
                            src: item.imageUrl,
                            showNameLogo: item.name
                          }, null, 8, ["src", "showNameLogo"]))
                    ], 64))
                  }), 128)),
                  (phaseAssignContractorAndMembers.value.length > 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("p", null, "+" + _toDisplayString(phaseAssignContractorAndMembers.value.length - 3), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_expansion_panel_text, null, {
          default: _withCtx(() => [
            _createElementVNode("main", _hoisted_11, [
              (__props.phase?.phaseType === _unref(EstimatePhaseType).MATERIALS)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (__props.phase?.estimationPhaseProperties.length)
                      ? (_openBlock(), _createBlock(AddressItem, {
                          key: 0,
                          showAddAction: false,
                          addressValue: 
                getPropertiesFirstValue(__props.phase?.estimationPhaseProperties)
              ,
                          countValue: 
                getPropertyAdditionalCount(
                  __props.phase?.estimationPhaseProperties.length
                )
              ,
                          properties: __props.phase?.estimationPhaseProperties
                        }, null, 8, ["addressValue", "countValue", "properties"]))
                      : (_openBlock(), _createBlock(Text, {
                          key: 1,
                          variant: "span"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("No Property")
                          ]),
                          _: 1
                        }))
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.phase?.estimationPhaseTasks, (task, index) => {
                return (_openBlock(), _createElementBlock("section", {
                  class: "phase-received-item__task-item",
                  key: index
                }, [
                  (__props.phase?.phaseType === _unref(EstimatePhaseType).LABOUR)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (task.estimationPhaseTasksProperties.length)
                          ? (_openBlock(), _createBlock(AddressItem, {
                              key: 0,
                              showAddAction: false,
                              addressValue: 
                  getPropertiesFirstValue(task.estimationPhaseTasksProperties)
                ,
                              countValue: 
                  getPropertyAdditionalCount(
                    task.estimationPhaseTasksProperties.length
                  )
                ,
                              properties: task.estimationPhaseTasksProperties
                            }, null, 8, ["addressValue", "countValue", "properties"]))
                          : (_openBlock(), _createBlock(Text, {
                              key: 1,
                              variant: "span"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("No Property")
                              ]),
                              _: 1
                            }))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("section", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(Text, { variant: "span" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(task.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    (__props.phase?.phaseType === _unref(EstimatePhaseType).LABOUR)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(Text, { variant: "span" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getDuration(
                    task?.phaseTaskStartDate,
                    task?.phaseTaskEndDate,
                    task.durationType
                  )), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(Text, {
                            variant: "span",
                            textWeight: "400",
                            textColor: "rgba(12, 15, 74, 0.5)"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getDurationType(task.durationType)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.phase?.phaseType === _unref(EstimatePhaseType).MATERIALS)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(Text, { variant: "span" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(task?.materialUnit || 0), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(Text, {
                            variant: "span",
                            textWeight: "400",
                            textColor: "rgba(12, 15, 74, 0.5)"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(task?.materialUnit > 1 ? "Units" : "Unit"), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(Text, { variant: "span" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(CurrencyFilter).formatToCurrency(task.taskCost)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (isShowPhaseNoteListModal.value)
      ? (_openBlock(), _createBlock(ShowPhaseNoteModal, {
          key: 0,
          isEstimateNote: true,
          phaseDetails: __props.phase?.phaseNotes,
          onOnClose: toggleShowPhaseNoteListModal
        }, null, 8, ["phaseDetails"]))
      : _createCommentVNode("", true),
    (
        isShowPhaseProofOfWorkModal.value && __props.phase?.estimatePhaseAttachment?.length
      )
      ? (_openBlock(), _createBlock(ShowPhaseProofOfWorkModal, {
          key: 1,
          phaseDetails: __props.phase,
          isEstimateAttachments: true,
          estimateId: __props.grantEstimateDetails?.id,
          onOnClose: togglePhaseProofOfWorkModal
        }, null, 8, ["phaseDetails", "estimateId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})